import { PartnerPagePathPiece } from 'clickNgo/entities/partner/configs'

export const checkGlobalPartnerPage = (pathname: string) =>
  pathname.includes(PartnerPagePathPiece.GlobalPartner)
